import React, { Suspense, lazy } from "react";
import { useEffect, useState } from "react";
import { Await, defer, useLoaderData } from "react-router-dom";
import ApiServices from "../../service/ApiServices";

import { useCart } from "../../app/context/cart-context/cart-context";


import { Spinner } from "../template/spinner/spinner";
import { Categories } from "./categories/categories";
import { ProductCard } from "../template/product-card/product-card";
import { AddToCartBtn } from "../template/buttons/add-to-cart-btn/add-to-cart-btn";
import { LikeButton } from "../template/buttons/like-btn/like-button";
import { QuantitySelector } from "../template/inputs/quantity-selector/quantity-selector";

import "./catalog.css";

const ProductsList = lazy(() => import('./products-list'))

const res = new ApiServices();

const Catalog = () => {
    const {cart} = useCart()

    const {categories, productsData} = useLoaderData();

    const [activeTab, setActiveTab] = useState({});

    const handleActiveTab = (tab) => {
        setActiveTab(tab)
    }

    const [products, setProducts] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [offset, setOffset] = useState(0);
    const [total, setTotal] = useState(0);


    useEffect(() => {
        res.getLazyProducts().then(data => {
            setProducts(data.result);
            setOffset(5);
            setTotal(data.total);
        });

    }, []);

    const getMore = () => {
        res.getLazyProducts(offset).then(data => {
            const result = data.result;
            const total = data.total;
            console.log(data);
            setProducts((prev) => {
                return prev.map((item, index) => {
                    const newData = result.find(d => d.category.id === item.category.id);
                    if (newData) {
                        return {...item, products: [...item.products, ...newData.products]}
                    } else {
                        return item;
                    }
                });
            });
            total > 0 ? setHasMore(true) : setHasMore(false);
        });
        setTotal((prevTotal) => prevTotal + total)
        setOffset((prevOffset) => prevOffset + 5);
    }

    return (
        <div  className="container">
            <div className="row">
                <Categories data={categories} isActive={activeTab}/>
                <Suspense fallback={ <Spinner/> }>
                    <ProductsList props={{products, total, hasMore, getMore}}  onActiveTab={handleActiveTab}/>
                </Suspense>
            </div>
        </div>
    )
}



const catalogLoader = async () => {

    return defer({
        categories: res.getCategories(),
        // productsData: res.getProductsByCategories(),
    })
}

export {Catalog, catalogLoader};